export type AcademicStatus =
  | 'approved'
  | 'failed'
  | 'attendance_failed'
  | 'progress_failed'
  | 'exempted'
  | 'progress'
  | 'in_progress'
  | 'cancelled'
  | 'inactive';

export const ACADEMIC_STATUS_MAP: Record<
  AcademicStatus,
  { label: string; color: string }
> = {
  approved: { label: 'Aprovado', color: 'success' },
  failed: { label: 'Reprovado', color: 'error' },
  attendance_failed: { label: 'Reprovado por frequência', color: 'error' },
  progress_failed: { label: 'Reprovado por progresso', color: 'error' },
  exempted: { label: 'Isento por aproveitamento', color: 'warning' },
  progress: { label: 'Em andamento', color: 'blue' },
  in_progress: { label: 'Em andamento', color: 'blue' },
  cancelled: { label: 'Cancelado', color: 'orange' },
  inactive: { label: 'Inativo', color: 'warning' }
};
